import "./quote-form.css";
import { FaCaretDown } from "react-icons/fa6";
import { BsFillGeoAltFill } from "react-icons/bs";
import { HiOutlineSwitchVertical } from "react-icons/hi";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function QuoteForm ({ register, setValue }) {
  const services = JSON.parse(localStorage.getItem("services")) || [];
  const stations = JSON.parse(localStorage.getItem("stations")) || [];
  const [tHome] = useTranslation("homePage");

  let currentLng = "es";
  localStorage.getItem("lng")
    ? (currentLng = localStorage.getItem("lng"))
    : (currentLng = "es");

  const [optionsView, setOptionsView] = useState("");
  const [origin, setOrigin] = useState("");
  const [destino, setDestino] = useState("");
  const [service, setService] = useState("");
  const [depText, setDepText] = useState(`${tHome("quote-shipping-form.select-dep-opt")}`);
  const [arrText, setArrText] = useState(`${tHome("quote-shipping-form.select-arr-opt")}`);

  const listServices =
    destino === "PBC" ||
    origin === "PBC" ||
    destino === "MEX2" ||
    origin === "MEX2"
      ? services.filter(
          (service) =>
            service.name !== "Animales Vivos" && service.name !== "Live Animals"
        )
      : services;

  const listCities =
    service === "Pharma XPS"
      ? stations.filter((city) => city.thumb !== "PBC")
      : stations;

  const handleDeparture = (data) => {
    setOptionsView('');
    setDepText(`${data.name} - ${data.code_text.substring(0, 3)}`)
    setValue("departure", data.code_text);
    setOrigin(data.code_text);
  }

  const handleArrival = (data) => {
    setOptionsView('');
    setArrText(`${data.name} - ${data.code_text.substring(0, 3)}`)
    setValue("arrival", data.code_text);
    setDestino(data.code_text);
  }

  const handleService = (data) => {
    setOptionsView('')
    setValue("service", data.name);
    setService(data.name);
  }

  const changeValues = () => {
    if(depText === 'Selecciona un Origen') return;
    if(arrText === 'Selecciona un Destino') return;
    setOptionsView('');
    setDepText(arrText);
    setArrText(depText);
    setValue("departure", destino);
    setValue("arrival", origin);
    setOrigin(destino);
    setDestino(origin);
  }

  return (
    <div className="quote-form-home">
      
      <div className="arr-dep-content inpt1">
        <div 
          className="information" 
          onClick={() => setOptionsView('departure')}
        >
          <div className="icon">
            <BsFillGeoAltFill />
          </div>

          <div className="input-text">
            <label><p>{tHome("quote-shipping-form.origin-label")}</p></label>
            <input id="departure" type="text" value={depText} readOnly {...register("departure", {required: true})} />
          </div>
        </div>

        <div 
          className="arrow" 
          onClick={() => setOptionsView('departure')}
        ><FaCaretDown /></div>

        
        <div className={`options-content ${optionsView === 'departure' ? "departure" : ''}`}>
          {listCities.filter((city) => city.lng === currentLng).map((city, index) => (
            <div 
              key={index}
              className="option-home" 
              onClick={() => handleDeparture(city)}
            >
              {city.name} ({city.code_text.substring(0, 3)})
            </div>
          ))}
        </div>
      </div>

      <div className="change-options" onClick={changeValues}>
        <HiOutlineSwitchVertical />
      </div>

      <div className="arr-dep-content inpt2">
        <div 
          className="information"
          onClick={() => setOptionsView('arrival')}
        >
          <div className="icon">
            <BsFillGeoAltFill />
          </div>

          <div className="input-text">
            <label><p>{tHome("quote-shipping-form.destination-label")}</p></label>
            <input id="arrival" type="text" value={arrText} readOnly {...register("arrival", {required: true})} />
          </div>
        </div>

        <div 
          className="arrow"
          onClick={() => setOptionsView('arrival')}
        ><FaCaretDown /></div>

        <div className={`options-content ${optionsView === 'arrival' ? "arrival" : ''}`}>
          {stations.filter((city) => city.lng === currentLng).map((city, index) => (
            <div 
              key={index}
              className="option-home" 
              onClick={() => handleArrival(city)}
            >
              {city.name} ({city.code_text.substring(0, 3)})
            </div>
          ))}
        </div>
      </div>


      <div className="service-type">
        <div className="arr-dep-content inpt3">
          <div 
            className="information"
            onClick={() => setOptionsView('service')}
          >

            <div className="input-text">
              <label><p>{tHome("quote-shipping-form.type-service-label")}</p></label>
              <input id="service" type="text" defaultValue={tHome("quote-shipping-form.select-service-opt")} readOnly {...register("service", {required: true})} />
            </div>
          </div>

          <div 
            className="arrow"
            onClick={() => setOptionsView('service')}
          ><FaCaretDown /></div>

          <div className={`options-content ${optionsView === 'service' ? "service" : ''}`}>
            {listServices.map((service, index) => (
              <div 
                key={index}
                className="option-home" 
                onClick={() => handleService(service)}
              >
                {service.name}
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  )
}

export default QuoteForm;